/**
 * Searches multiple properties on a list of model for any matches (OR conditional match)
 * Note: on upper vs lower case - Ideally neither but if you have to upper (apprently)
 * https://stackoverflow.com/questions/234591/upper-vs-lower-case
 *
 * @param input - model list
 * @param fields - model fields/properties to check - note: won't work for boolean fields/properties
 * @param query - value to search for
 */
(function() {
    'use strict';

    angular.module('app').filter('multipleFieldSearchFilter', function() {

        return function(input, fields, query) {
            if (!fields || fields.length === 0) return input;
            if (!query || query.length === 0) return input;
            var out = [], matched;
            angular.forEach(input, function (item) {
                matched = false;
                angular.forEach(fields, function (field) {
                    //Will no perform another check once item is matched
                    if(!matched && item[field]){
                        if( item[field].toUpperCase().indexOf( query.toUpperCase() )!==-1 ){
                            matched = true;
                        }
                    }
                });
                if(matched){
                    out.push(item);
                }
            });
            return out;
        }

    });

}());